import React from "react";
import SideBar from "./SideBar";
import Book from "./Books/Book";
import BookChapters from "./Books/BookChapters";

const Books = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-3">
          <SideBar books = {true}/>
        </div>
        <div className="col-lg-9 padding-lg">
          <div className="heading mt-5"> Books and Book Chapters </div>
          <hr />
          <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <a
                className="nav-item nav-link active"
                id="nav-books-tab"
                data-bs-toggle="tab"
                href="#nav-books"
                role="tab"
                aria-controls="nav-books"
                aria-selected="true"
              >
                Books
              </a>
              <a
                className="nav-item nav-link"
                id="nav-bookChapter-tab"
                data-bs-toggle="tab"
                href="#nav-bookChapter"
                role="tab"
                aria-controls="nav-bookChapter"
                aria-selected="false"
              >
                Book Chapters
              </a>
            </div>
          </nav>
          <div className="tab-content" id="nav-tabContent">
            <div
              className="tab-pane fade show active"
              id="nav-books"
              role="tabpanel"
              aria-labelledby="nav-books-tab"
            >
              <div className="my-4">
                <Book/>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="nav-bookChapter"
              role="tabpanel"
              aria-labelledby="nav-bookChapter-tab"
            >
              <div className="my-4">
                <BookChapters/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Books;
